import { CustomerData } from "../../types";
import api from "../../../../../features/auth/axiosConfig";
import { useState } from "react";
import { ledgerPaid } from "src/printConfigration/PrintConfigration";
import { notifyError, notifySuccess } from "src/assets/toastService";
export const usePayment = (customerData: CustomerData, customerId: string, onClose: () => void, refetchLedger: () => void) => {
  const [paymentLoading, setPaymentLoading] = useState<boolean>(false);
  const [print, setPrintData] = useState<ledgerPaid>();
  const handlePayment = async (amount: string, method: string) => {
    setPaymentLoading(true);
    if (!amount || parseFloat(amount) <= 0) {
      notifyError("Enter a valid amount");
      return;
    }
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");

    try {
      // Calculate total outstanding balance from all ledger entries
      const totalOutstandingBalance = customerData.ledger.reduce((sum, ledgerItem) => {
        return sum + parseFloat(ledgerItem.total_outstanding_balance || "0");
      }, 0);

      // Calculate new outstanding balance after payment
      const newOutstandingBalance = totalOutstandingBalance;

     const res = await api.post("/pos/ledger", {
        id: customerId,
        outstanding_balance: newOutstandingBalance,
        orderamount: "0",
        pay_amount: parseFloat(amount),
        order_id: method || "Payment only",
        payment_method: method,
        Orderdate: `${year}-${month}-${day}`,
        Ordertime: `${currentDate.getHours()}:${currentDate.getMinutes()}`,
      });

      const printData: ledgerPaid = {
        Balance: Number(newOutstandingBalance.toFixed(2)),
        Paid: Number(amount),
        billNo: res.data.billNumber,
        clientId: String(customerData?.ledger[0].customer_ref_id),
        CustomerPhon: Number(customerData.ledger[0].customer_phone_number),
        CustomerName: customerData.ledger[0].customer_name || "",
        Time: `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`,
        Date: `${year}-${month}-${day}`,
        paymentMethod: method || "",
      };
      setPrintData(printData);
      notifySuccess("Price received successfully");
      setTimeout(() => {
        refetchLedger();
        onClose();
      }, 2000);
    } catch (error) {
      console.error("Payment error:", error);
      notifyError("Payment failed. Try again.");
      setPaymentLoading(false);
    }
  };

  return { handlePayment, paymentLoading, print };
};
